import React, { useState } from 'react'
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { useSnackbar } from 'notistack'

/** `iconOnly` renders it as an icon button with `label` as the tooltip, to sit beside edit/delete. */
export const ExportButton = ({ exportFn, filename, label = 'EXPORT', iconOnly, ...props }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const handleExport = async () => {
    setIsLoading(true)
    try {
      const res = await exportFn()
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      enqueueSnackbar('Exported successfully', { variant: 'success' })
    } catch (err) {
      console.error(err)
      enqueueSnackbar('Export failed', { variant: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  if (iconOnly) {
    return (
      <Tooltip title={label}>
        {/* A disabled button fires no events, so the tooltip needs a live element to listen on. */}
        <span>
          <IconButton onClick={handleExport} disabled={isLoading} {...props}>
            {isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  return (
    <Button
      startIcon={<DownloadIcon />}
      onClick={handleExport}
      disabled={isLoading}
      endIcon={isLoading && <CircularProgress size={16} />}
      {...props}
    >
      {label}
    </Button>
  )
}
